import { render, staticRenderFns } from "./formYoutube.vue?vue&type=template&id=6501031e&"
import script from "./formYoutube.vue?vue&type=script&lang=js&"
export * from "./formYoutube.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports